/* unplugin-vue-components disabled */import script from "./PikerWeek.vue?vue&type=script&setup=true&lang=ts"
export * from "./PikerWeek.vue?vue&type=script&setup=true&lang=ts"

import "./PikerWeek.vue?vue&type=style&index=0&id=5f4149a6&lang=less"

const __exports__ = script;

export default __exports__